// extracted by mini-css-extract-plugin
export const content = "tech-stack-module--content--1Gb3l";
export const tag = "tech-stack-module--tag--1WEdm";
export const tagDisplay = "tech-stack-module--tagDisplay--3gzEO";